import Callback from './components/Callback'

export default Callback
